import React from 'react';

import { SegmentedButtonProps } from '.';
import { SegmentedButtonWrapper } from './SegmentedButton.styles';

const SegmentedButton: React.FC<SegmentedButtonProps> = ({
  size,
  variant,
  selected,
  active,
  children,
  ...props
}) => {
  return (
    <SegmentedButtonWrapper size={size} {...props}>
      {React.Children.map(children, (child: SegmentedButtonProps['children']) => {
        return React.isValidElement(child)
          ? React.cloneElement(child, { size, variant, selected, active })
          : child;
      })}
    </SegmentedButtonWrapper>
  );
};

export default SegmentedButton;
